{
  "title": "Уведомления",
  "readAll": "Прочитать все",
  "empty": "Уведомлений пока нет",
  "emptyUnread": "Новых уведомлений нет",
  "showRead": "Показать прочитанные",
  "hideRead": "Скрыть прочитанные",
  "loadFailed": "Не удалось загрузить уведомления",
  "readAllFailed": "Не удалось отметить уведомления прочитанными",
  "unnamed": "Без имени",
  "assigned": "назначил(-а) вас исполнителем",
  "mentionedInComment": "упомянул(-а) вас в комментарии",
  "mentionedInDescription": "упомянул(-а) вас в описании",
  "unread": "Есть непрочитанные уведомления",
  "companyUnread": "Непрочитанных уведомлений: {{count}}"
}
